module.exports = __webpack_public_path__ + "src/img/ziyuan_on.4c82d839.svg";